import { Directive, Input, OnInit } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[formControl][transform],[formControlName][transform]"
})
export class TransformDirective implements OnInit {
  @Input() public readonly transform: (data: any) => any;

  public originalGetValue?: () => any;

  constructor(
    private readonly ngControl: NgControl,
  ) {
  }

  public ngOnInit() {
    this.originalGetValue = this.ngControl.control.getRawValue

    this.ngControl.control.getRawValue = this.transformValue
  }

  transformValue = () => {
    const rawValue = this.originalGetValue.call(this.ngControl.control);
    return this.transform(rawValue);
  }
}